export enum Redirect {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL"
}